import TableRowTag from "../../TableRowTag";
import Tooltip from "../../../../../components/shared/Tooltip/Tooltip";
import {
  formatPrimaryValue,
  formatZScore,
  getZScoreColorClass,
  normalizeZScore,
  normalizeZScoreColor,
} from "../../../utils/metrics";

export function createDynamicIndicatorColumns({
  savedIndicators,
  tourAveragesToggle,
}) {
  const dynamicCols = [];

  if (savedIndicators?.length) {
    dynamicCols.push(
      ...savedIndicators.map((el) => ({
        accessorKey: `analysis.${el.id}`,
        header: el.name,
        id: el.id,
        size: 50,
        cell: ({ row }) => {
          const { analysis = {} } = row.original || {};
          const indicator = analysis[el.id] ?? {};

          const metric = {
            avg: indicator?.value ?? null,
            unit: indicator?.unit ?? el.unit,
            zScore: normalizeZScore(indicator?.zScore),
            zScoreColor: normalizeZScoreColor(indicator?.zScore),
          };

          return (
            <div className="flex flex-col items-start gap-2.5">
              <span className="text-gray900 w-fit text-sm">
                {metric.avg !== null ? (
                  formatPrimaryValue(metric, el.unit)
                ) : (
                  <Tooltip
                    content={
                      <span>
                        This swing hasn&apos;t been analyzed yet. Open it in
                        Sportsbox to analyze its 3D data.
                      </span>
                    }
                  >
                    <p>n/a</p>
                  </Tooltip>
                )}
              </span>

              {tourAveragesToggle && (
                <span className={`text-sm ${getZScoreColorClass(metric)}`}>
                  {formatZScore(metric)}
                </span>
              )}
            </div>
          );
        },
      })),
    );
  }

  return dynamicCols;
}

export function createFixedColumns() {
  return [
    {
      accessorKey: "userData.golfClub",
      header: "Club",
      id: "club",
    },
    {
      accessorKey: "userData.fullName",
      header: "Golfer",
      id: "golfer",
    },
    {
      accessorKey: "tags",
      header: "Tags",
      id: "tags",
      cell: ({ row }) => (
        <TableRowTag
          values={row?.original?.tags ? row?.original?.tags : []}
          videoId={row?.original?.id}
        />
      ),
    },
  ];
}
